import { useRef, useCallback } from "react";
import { useEventListener } from "./use-event-listener.es.js";
function useMouseTracker() {
  const trackerRef = useRef({ isMouseDown: false });
  useEventListener(
    "mousedown",
    useCallback(() => {
      trackerRef.current.isMouseDown = true;
    }, [])
  );
  useEventListener(
    "mouseup",
    useCallback(() => {
      trackerRef.current.isMouseDown = false;
    }, [])
  );
  return trackerRef.current;
}
export {
  useMouseTracker
};
